import React from 'react';
import { EstimatedTradeCostComparisonWidgetGrid } from './grid/EstimatedTradeCostComparisonWidgetGrid';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { EstimatedTradeCostComparisonWidgetContentLeftHandPanel } from './EstimatedTradeCostComparisonWidgetContentLeftHandPanel';

import './EstimatedTradeCostComparisonWidgetContent.scss';
import { EstimatedTradeCostComparisonData } from 'widgets/estimatedTradeCost/widget-comparison/estimatedTradeCostComparisonData';

export function EstimatedTradeCostComparisonWidgetContent({
    data,
    editedQty,
    isQuantityDirty,
    onGridApiSet,
    onQtyChanged,
    height,
    onClickRefresh,
}: {
    data: EstimatedTradeCostComparisonData | undefined;
    editedQty: number | undefined;
    isQuantityDirty: boolean;
    onGridApiSet: (gridApi: GridApi) => void;
    onQtyChanged: (qty: number) => void;
    height: number;
    onClickRefresh: () => void;
}) {
    const zeroQuantity = !(
        data?.firstRequest?.orderQtyRemaining ||
        data?.firstRequest?.specifiedQty
    );

    return (
        <div className="EstimatedTradeCostComparisonWidgetContent">
            <EstimatedTradeCostComparisonWidgetContentLeftHandPanel
                data={data}
                editedQty={editedQty}
                onQtyChanged={onQtyChanged}
            />
            <EstimatedTradeCostComparisonWidgetGrid
                data={data}
                height={height}
                isQuantityDirty={isQuantityDirty}
                zeroQuantity={zeroQuantity}
                onGridApiSet={onGridApiSet}
                onClickRefresh={onClickRefresh}
            />
        </div>
    );
}
